import { getTermsValue, resetTerms, setTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { createTagValue } from '../../utils/createTagValue';
import { getValueToTagLabelMap } from './utils';

const ID = 'promoSearchType' as const;

export const promoSearchTypeTagsManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery, promoSearchTypes }) => {
    const promoSearchTypesData = getTermsValue('promo_search_types')(jsonQuery);

    if (promoSearchTypesData === null || !promoSearchTypes) {
      return null;
    }

    return promoSearchTypesData.map(promoSearchType => ({
      label: getValueToTagLabelMap(promoSearchTypes).get(promoSearchType) || 'Акция от застройщика',
      value: createTagValue(ID, promoSearchType),
    }));
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery, removingTagValue }) => {
    const promoSearchTypesData = getTermsValue('promo_search_types')(jsonQuery);

    if (promoSearchTypesData === null) {
      return jsonQuery;
    }

    const newPromoSearchTypes = promoSearchTypesData.filter(promoSearchType => promoSearchType !== removingTagValue);

    return newPromoSearchTypes.length
      ? setTerms('promo_search_types')(jsonQuery)(newPromoSearchTypes)
      : resetTerms(['promo_search_types'])(jsonQuery);
  },
};
